import React, { useState, useEffect } from "react"
import {
  Container,
  StepperContainer,
  StepperHeader,
  StepperHeaderElement,
  Alert,
} from 'design-react-kit';

import SibaBreadcrumb from "../components/common/SibaBreadcrumb";
import SibaTabellaVeicoliAttivi from "../components/rimborsi/SibaTabellaVeicoliAttivi";
import SibaMostraSituazionePagamenti from "../components/rimborsi/SibaMostraSituazionePagamenti";
import * as Constants from '../utils/constants'
import ErrorBoundary from "../components/common/ErrorBoundary";
import SibaMostraDettagliVeicolo from "../components/rimborsi/SibaMostraDettagliVeicolo";
import SibaMostraDettagliPagamento from "../components/rimborsi/SibaMostraDettagliPagamento";
import SibaMostraSceltaRimborso from "../components/rimborsi/SibaMostraSceltaRimborso"
import SibaInputFormRichiestaRimborso from "../components/rimborsi/SibaInputFormRichiestaRimborso";
import { authenticate } from '../services/endpoints'
import { isUndefined, isPresentAuthenticatedUser } from "../utils/utilities";
import { formatDataPagamento } from "../utils/format";
import SibaListaRichiesteRimborso from "../components/rimborsi/SibaListaRichiesteRimborso";

export const SibaRimborsiMain = ({ authMode }) => {

  // User data
  const [codiceFiscale, setCodiceFiscale] = useState(sessionStorage.getItem(Constants.USER_IN_SESSION));
  const [veicolo, setVeicolo] = useState({});
  const [schedaPagamento, setSchedaPagamento] = useState({});
  const [dettaglioPagamenti, setDettaglioPagamenti] = useState([]);

  // Navigation
  const [currentStep, setCurrentStep] = useState(Constants.STEP_1);
  const [choiceDettagli, setChoiceDettagli] = useState('');
  const [choiceRimborso, setChoiceRimborso] = useState('');
  const [choicePagamento, setChoicePagamento] = useState('');

  useEffect(() => {
    const loadCurrentUser = async () => {
      let user = await authenticate();
      console.log('App.js user=', user)
      if (user !== undefined) {
        if (!isUndefined(user.user)) {
          console.log('App.js user id=', user.user)
          sessionStorage.setItem(Constants.USER_IN_SESSION, user.user)
        };
      }
    }

    if (!isPresentAuthenticatedUser() && (authMode === Constants.AUTH_MODE_PROTECTED)) {
      loadCurrentUser();
    }
  }, [])

  const initDatiVeicoloForzati = () => {
    if (dettaglioPagamenti.length > 0) {
      //TODO criterio di scelta in caso array.length > 1? Attualmente prendo il primo della lista
      const dettaglioPagamento = dettaglioPagamenti[0];
      console.log('initDatiVeicoloForzati dettaglioPagamento', dettaglioPagamento)
      const datiVeicoloForzati = {
        "targa": veicolo && veicolo.targa ? veicolo.targa : '',
        "validita": dettaglioPagamento.validita,
        "scadenza": dettaglioPagamento.dataScadenza.anno.toString() + "-" + String(dettaglioPagamento.dataScadenza.mese.idDecodifica.id).padStart(2, '0'),
        "dataPagamento": formatDataPagamento(dettaglioPagamento.dataPagamentoEffettuato),
        "tipoVeicolo": {
          "value": dettaglioPagamento.tipoVeicolo.idDecodifica.id,
          "label": dettaglioPagamento.tipoVeicolo.descrizione
        }
      }

      console.log('initDatiVeicoloForzati datiVeicoloForzati', datiVeicoloForzati)
      return datiVeicoloForzati;
    } else {
      return {}
    }
  }

  //SETTERS
  const handleBack = () => { if (currentStep > Constants.STEP_1) { setCurrentStep(currentStep - 1) } };
  const handleNext = () => { setCurrentStep(currentStep + 1); };
  const handleChangeCodiceFiscale = (cfInInput) => { setCodiceFiscale(cfInInput.toUpperCase()) }; // currentStep: 2
  const handleVeicoloSelezionato = (data) => { setVeicolo(data.veicolo); setChoiceDettagli(data.choice); handleNext() };
  const handleRichiestaPagamento = (data) => { setSchedaPagamento(data.schedaPagamento); setChoicePagamento(data.choice); handleNext() };
  const handleSceltaTipoRimborso = (_choice) => { console.log(_choice); setChoiceRimborso(_choice) };
  const handleDettaglioPagamentiLoaded = (data) => { console.log('handleDettaglioPagamentiLoaded', data); setDettaglioPagamenti(data) };
  const handleSceltaPagamentoDaRimborsare = (data) => { console.log("handleSceltaPagamentoDaRimborsare", data); setChoicePagamento(data.choice) };

  const showStep1_SceltaRimborso = () => {
    return (
      <SibaMostraSceltaRimborso
        cf={sessionStorage.getItem(Constants.USER_IN_SESSION)}
        handleChoice={handleSceltaTipoRimborso}
        handleBack={handleBack}
        handleNext={handleNext} />
    )
  }

  const showStep2_basedOnChoiceRimborso = () => {
    console.log('choiceRimborso', choiceRimborso);
    switch (choiceRimborso) {
      case Constants.RIM_CHOICE_RIMBORSO_ELENCORICHIESTE:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaListaRichiesteRimborso
              handleBack={handleBack} />
          </ErrorBoundary>
        )
      case Constants.RIM_CHOICE_RIMBORSO_ELENCOVEICOLI:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaTabellaVeicoliAttivi
              cf={sessionStorage.getItem(Constants.USER_IN_SESSION)}
              handleChoice={handleVeicoloSelezionato}
              handleBack={handleBack} />
          </ErrorBoundary>
        )
      case Constants.RIM_CHOICE_RIMBORSO_CICLOMOTORI:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaInputFormRichiestaRimborso
              cf={codiceFiscale}
              targa={veicolo && veicolo.targa ? veicolo.targa : ''}
              choiceRimborso={choiceRimborso}
              allineamento={false}
              handleCfChange={handleChangeCodiceFiscale}
              handleNext={handleNext}
              handleBack={handleBack}
              isCfDisabled={true} 
              numeroAllegati="3"/>
          </ErrorBoundary>
        )
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaInputFormRichiestaRimborso
              cf={codiceFiscale}
              targa={''}
              choiceRimborso={choiceRimborso}
              allineamento={false}
              handleCfChange={handleChangeCodiceFiscale}
              handleNext={handleNext}
              handleBack={handleBack}
              isCfDisabled={false} 
              numeroAllegati="2"/>
          </ErrorBoundary>
        )  
      //STALIGK-793: aggiunto veicoli aziendali fuori regione   
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE:  
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaInputFormRichiestaRimborso
              cf={codiceFiscale}
              targa={''}
              choiceRimborso={choiceRimborso}
              allineamento={false}
              handleCfChange={handleChangeCodiceFiscale}
              handleNext={handleNext}
              handleBack={handleBack}
              isCfDisabled={false} 
              numeroAllegati="2"/>
          </ErrorBoundary>
        )

      case Constants.RIM_CHOICE_RIMBORSO_LEASING:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaInputFormRichiestaRimborso
              cf={codiceFiscale}
              targa={''}
              choiceRimborso={choiceRimborso}
              allineamento={false}
              handleCfChange={handleChangeCodiceFiscale}
              handleNext={handleNext}
              handleBack={handleBack}
              isCfDisabled={false} 
              numeroAllegati="3"/>
          </ErrorBoundary>
        )
      
      case Constants.RIM_CHOICE_RIMBORSO_EREDI:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaInputFormRichiestaRimborso
              cf={codiceFiscale}
              targa={''}
              choiceRimborso={choiceRimborso}
              allineamento={false}
              handleCfChange={handleChangeCodiceFiscale}
              handleNext={handleNext}
              handleBack={handleBack}
              isCfDisabled={false} 
              numeroAllegati="5"/>
          </ErrorBoundary>
        )
      case Constants.RIM_CHOICE_RIMBORSO_FUORIREGIONE:
      case Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaInputFormRichiestaRimborso
              cf={codiceFiscale}
              targa={''}
              choiceRimborso={choiceRimborso}
              allineamento={false}
              handleCfChange={handleChangeCodiceFiscale}
              handleNext={handleNext}
              handleBack={handleBack}
              isCfDisabled={false} 
              numeroAllegati="2"/>
          </ErrorBoundary>
        )
      default:
        return showAlertForStep(currentStep);
    }
  }

  const showStep3 = () => {
    console.log('choiceDettagli=', choiceDettagli)
    switch (choiceDettagli) {
      case Constants.RIM_CHOICE_DETTAGLI_PAGAMENTI:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaMostraSituazionePagamenti
              _veicolo={veicolo}
              _handleSubmit={handleRichiestaPagamento}
              _handleBack={handleBack} />
          </ErrorBoundary>
        )
      case Constants.RIM_CHOICE_DETTAGLI_DETTAGLI:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaMostraDettagliVeicolo
              veicolo={veicolo}
              handleBack={handleBack} />
          </ErrorBoundary>
        )
      default:
        return showAlertForStep(currentStep);
    }
  }

  const showStep4 = () => {
    console.log('showStep4_choicePagamento=', choicePagamento)
    switch (choicePagamento) {
      case Constants.RIM_CHOICE_PAGAMENTO_VISUALIZZA:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaMostraDettagliPagamento
              schedaPagamento={schedaPagamento}
              veicolo={veicolo}
              handleSubmit={handleSceltaPagamentoDaRimborsare}
              handleBack={handleBack}
              handleDataLoaded={handleDettaglioPagamentiLoaded}
            />
          </ErrorBoundary>
        )
      case Constants.RIM_CHOICE_PAGAMENTO_RIMBORSA:
      case Constants.RIM_CHOICE_PAGAMENTO_ALLINEA:
        const datiVeicoloForzati = initDatiVeicoloForzati();
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO} >
            <SibaInputFormRichiestaRimborso
              cf={codiceFiscale}
              targa={datiVeicoloForzati.targa}
              datiVeicoloForzati={datiVeicoloForzati}
              choiceRimborso={choiceRimborso}
              allineamento={choicePagamento === Constants.RIM_CHOICE_PAGAMENTO_ALLINEA}
              handleCfChange={handleChangeCodiceFiscale}
              handleNext={handleNext}
              handleBack={handleBack}
              isCfDisabled={true} 
              numeroAllegati={dettaglioPagamenti.length > 1 ? "3" : "2"}/>
          </ErrorBoundary>
        )
      default:
        return showAlertForStep(currentStep);
    }
  }

  const getStepContent = (step) => {
    console.log("Current step= #" + currentStep)
    switch (step) {
      case Constants.STEP_1: return showStep1_SceltaRimborso();
      case Constants.STEP_2: return showStep2_basedOnChoiceRimborso();
      case Constants.STEP_3: return showStep3();
      case Constants.STEP_4: return showStep4();
      default: return showAlertForStep(step);
    }
  }

  const showAlertForStep = (step) => {
    return (
      <Container className="px-2 my-2" id="rimborsiMain" tag="section">
        <Alert color="warning">Unknown step # {step}!</Alert>
      </Container>
    )
  }

  const OurFallbackComponentTODO = ({ error, componentStack, resetErrorBoundary }) => {
    return (
      <Container className="px-2 my-2" id="rimborsiMainFail" tag="section">
        <Alert color="danger">Errore in Rimborsi! {error.message}</Alert>
      </Container>
    );
  };

  const getVariantForStep = (step) => {
    if (currentStep > step) return Constants.VARIANT_CONFIRMED;
    if (currentStep < step) return null;
    if (currentStep === step) return Constants.VARIANT_ACTIVE;
  }

  //START RENDERING
  return (
    <Container className="px-2 my-2" id="stepper-header" tag="section">
      <SibaBreadcrumb pageName={Constants.STR_RIMBORSI_TITOLO} />
      <StepperContainer tag="div">
        <StepperHeader tag="ul">
          <>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_1}</>}
              variant={getVariantForStep(Constants.STEP_1)}
              noLine
            > <>{Constants.STR_RIMBORSI_TIPO_RIMBORSO}</>
            </StepperHeaderElement>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_2}</>}
              variant={getVariantForStep(Constants.STEP_2)}
              noLine
            > <>{currentStep >= Constants.STEP_2 ? choiceRimborso : Constants.STR_RIMBORSI_INSERIMENTO_DATI}</>
            </StepperHeaderElement>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_3}</>}
              variant={getVariantForStep(Constants.STEP_3)} //NOTA: deve restare acceso anche per step = 4 o 5
              noLine
            > <>{currentStep >= Constants.STEP_3 ? choiceDettagli : Constants.STR_RIMBORSI_DETTAGLI}</>
            </StepperHeaderElement>
            {
              currentStep >= Constants.STEP_4 ? (
                <StepperHeaderElement
                  stepperNumber={<>{Constants.STEP_4}</>}
                  variant={getVariantForStep(Constants.STEP_4)}
                  noLine
                > <>{currentStep >= Constants.STEP_4 ? choicePagamento : "-"}</>
                </StepperHeaderElement>) : (<></>)
            }
          </>
        </StepperHeader>
      </StepperContainer>
      <Container className="px-2 my-2" id="stepper-content" tag="section">
        {getStepContent(currentStep)}
      </Container>
    </Container >
  )
}

export default SibaRimborsiMain;
